import React, { FC } from 'react';
import {
  IReportBuilderFormik,
  TGroupingItem,
  TargetType,
} from 'domains/ReportBuilder/types';
import ReportSelect from '../../ReportSelect';

interface IRenderCatalogFilteringProps {
  item: TGroupingItem;
  formikKey: keyof IReportBuilderFormik['reportFilters'];
  currentKey: string;
  selectRef: React.RefObject<any>;
  openedFilter: string | null;
  setOpenedFilter: React.Dispatch<React.SetStateAction<string | null>>;
}

export const RenderCatalogFiltering: FC<IRenderCatalogFilteringProps> = ({
  item,
  formikKey,
  currentKey,
  selectRef,
  openedFilter,
  setOpenedFilter,
}) => {
  const { data, label } = item;
  const targetOptionsData = data as TargetType[];

  return (
    <ReportSelect
      key={currentKey}
      formikKey={formikKey}
      options={targetOptionsData}
      label={label}
      currentKey={currentKey}
      selectRef={selectRef}
      openedFilter={openedFilter}
      setOpenedFilter={setOpenedFilter}
    />
  );
};
